var map = {
	"./about/community-gardens-about-2-xl.jpg": 174,
	"./about/community-gardens-about-3-xl.jpg": 175,
	"./about/community-gardens-about-xl.jpg": 176,
	"./gallery/community-gardens-gallery-1-xl.jpg": 269,
	"./gallery/community-gardens-gallery-10-xl.jpg": 270,
	"./gallery/community-gardens-gallery-11-xl.jpg": 271,
	"./gallery/community-gardens-gallery-12-xl.jpg": 272,
	"./gallery/community-gardens-gallery-13-xl.jpg": 273,
	"./gallery/community-gardens-gallery-14-xl.jpg": 274,
	"./gallery/community-gardens-gallery-15-xl.jpg": 275,
	"./gallery/community-gardens-gallery-16-xl.jpg": 276,
	"./gallery/community-gardens-gallery-17-xl.jpg": 277,
	"./gallery/community-gardens-gallery-18-xl.jpg": 278,
	"./gallery/community-gardens-gallery-19-xl.jpg": 279,
	"./gallery/community-gardens-gallery-2-xl.jpg": 280,
	"./gallery/community-gardens-gallery-20-xl.jpg": 281,
	"./gallery/community-gardens-gallery-21-xl.jpg": 282,
	"./gallery/community-gardens-gallery-22-xl.jpg": 283,
	"./gallery/community-gardens-gallery-23-xl.jpg": 284,
	"./gallery/community-gardens-gallery-24-xl.jpg": 285,
	"./gallery/community-gardens-gallery-25-xl.jpg": 286,
	"./gallery/community-gardens-gallery-26-xl.jpg": 287,
	"./gallery/community-gardens-gallery-27-xl.jpg": 288,
	"./gallery/community-gardens-gallery-28-xl.jpg": 289,
	"./gallery/community-gardens-gallery-29-xl.jpg": 290,
	"./gallery/community-gardens-gallery-3-xl.jpg": 291,
	"./gallery/community-gardens-gallery-30-xl.jpg": 292,
	"./gallery/community-gardens-gallery-31-xl.jpg": 293,
	"./gallery/community-gardens-gallery-32-xl.jpg": 294,
	"./gallery/community-gardens-gallery-4-xl.jpg": 295,
	"./gallery/community-gardens-gallery-5-xl.jpg": 296,
	"./gallery/community-gardens-gallery-6-xl.jpg": 297,
	"./gallery/community-gardens-gallery-7-xl.jpg": 298,
	"./gallery/community-gardens-gallery-8-xl.jpg": 299,
	"./gallery/community-gardens-gallery-9-xl.jpg": 300,
	"./headers/about-community-gardens-xl.jpg": 301,
	"./headers/community-gardens-data-xl.jpg": 302,
	"./headers/community-gardens-fall-xl.jpg": 303,
	"./headers/community-gardens-summer-xl.jpg": 304,
	"./headers/credits-xl.jpg": 305,
	"./headers/out-of-state-xl.jpg": 306,
	"./headers/presentation-xl.jpg": 307,
	"./headers/solutions-xl.jpg": 308,
	"./plants/age-xl.jpg": 309,
	"./plants/anxiety-xl.jpg": 310,
	"./plants/degree-xl.jpg": 311,
	"./plants/energy-outgoing-xl.jpg": 312,
	"./plants/first-generation-xl.jpg": 313,
	"./plants/food-insecurity-xl.jpg": 314,
	"./plants/high-gpa-xl.jpg": 315,
	"./plants/high-resources-xl.jpg": 316,
	"./plants/housing-insecurity-xl.jpg": 317,
	"./plants/out-of-state-xl.jpg": 318,
	"./plants/random-garden-xl.jpg": 319,
	"./plants/solomons-seal-summer-xl.jpg": 320,
	"./plants/summer-garden-xl.jpg": 321,
	"./plants/wellness-xl.jpg": 322,
	"./plants/winter-garden-xl.jpg": 323,
	"./plants/xmas-xl.jpg": 324
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 642;


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*\-xl\.jpg$
// module id = 642
// module chunks = 11